export interface SalesDespatchItemSalesPack {
  id: string;
  stockNo: string;
  orderNo: string;
  shipperKey: string;
  shipperName: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  selected: boolean;
  canDelete: boolean;
}
